module.exports = __webpack_public_path__ + "static/media/history.819ab9a6.svg";